export const libraryExtractedMessages = {
  "library.ebook.private": "Private local file",
  "library.ebook.title": "Read and resume ebook",
  "library.ebook.explanation":
    "PDF uses its document page index. Reflowable EPUB uses a location and percentage; screen pages are never presented as print pages.",
  "library.ebook.add": "Add DRM-free EPUB or PDF",
  "library.ebook.uploaded":
    "A new file revision was added. Its position starts separately.",
  "library.ebook.saved": "Reading position and session saved",
  "library.ebook.error": "The ebook action could not be completed",
  "library.ebook.revision": "File revision",
  "library.ebook.revisionOption": "{name} · {format} · revision {revision}",
  "library.ebook.progress": "Progress: {percent}%",
  "library.ebook.pdfPage": "PDF page index (starts at 0)",
  "library.ebook.resource": "EPUB resource",
  "library.ebook.anchor": "EPUB anchor or CFI",
  "library.ebook.contents": "Table of contents",
  "library.ebook.currentLocation": "Current location",
  "library.ebook.openPdf": "Open private PDF",
  "library.ebook.save": "Save position and session",
  "library.ebook.delete": "Delete private file",
  "library.ebook.deleteTitle": "Delete this private ebook file?",
  "library.ebook.deleteDescription":
    "The file and its resume position will be permanently removed. Reading sessions and attributed quotes remain in your private history.",
  "library.EditionProgress.eyebrow": "This edition contains multiple works",
  "library.EditionProgress.title": "Edition progress",
  "library.EditionProgress.loading": "Loading edition components",
  "library.EditionProgress.loadError": "We couldn’t load edition progress",
  "library.EditionProgress.loadErrorHelp":
    "Your overall reading progress is unchanged.",
  "library.EditionProgress.metadataWarning": "Component details may be incomplete",
  "library.EditionProgress.metadataWarningHelp":
    "Some page ranges are missing or overlap. Celsus shows known progress without guessing.",
  "library.EditionProgress.current": "Current work",
  "library.EditionProgress.rangeUnknown": "Page range unknown",
  "library.EditionProgress.openComponent": "Open separately owned edition",
  "library.EditionProgress.next": "Next work",
  "library.summary.title": "Reading summary",
  "library.summary.private": "Private to you",
  "library.summary.loading": "Loading reading summary",
  "library.summary.error": "We couldn't load the reading summary",
  "library.summary.time": "Reading time",
  "library.summary.pages": "Pages logged",
  "library.summary.ebookProgress": "Ebook progress",
  "library.summary.sessions": "Sessions",
  "library.summary.completions": "Completed reads",
  "library.summary.noActivity": "No reading activity yet",
  "library.summary.dnf": "{count} did not finish",
  "library.summary.omnibus": "Omnibus edition",
  "library.summary.journal":
    "Journal: {notes} notes, {quotes} quotes, {highlights} highlights, {reflections} reflections",
  "library.summary.rating": "Your rating: {rating}/5",
  "library.summary.noRating": "Not rated",
  "library.summary.reviewPublished": "review published",
  "library.summary.reviewPrivate": "review private",
  "library.summary.reflections": "Recent private reflections",
  "library.summary.missingMetadata": "Missing metadata: {fields}",
  "library.reread.action": "Read again",
  "library.reread.started": "A new reading cycle has started",
  "library.reread.completions":
    "{count, plural, one {# completed read} other {# completed reads}}",
  "library.reread.cycle": "Cycle {count}",
  "library.reread.error": "A new reading cycle could not be started",
  "library.NextBook.privateTool": "Private library tool",
  "library.NextBook.title": "Choose my next book",
  "library.NextBook.description":
    "Narrow your To read shelf with optional constraints. Celsus only uses metadata, shelves, and tags already in your private library.",
  "library.NextBook.mood": "Mood tag or shelf",
  "library.NextBook.genre": "Genre",
  "library.NextBook.format": "Format tag or shelf",
  "library.NextBook.language": "Language",
  "library.NextBook.maxPages": "Maximum pages",
  "library.NextBook.availableMinutes": "Available time (minutes)",
  "library.NextBook.choose": "Choose books",
  "library.NextBook.clear": "Clear",
  "library.NextBook.metadataNote":
    "Time uses a visible estimate of two minutes per page. Missing genre, language, or page count is disclosed, never guessed.",
  "library.NextBook.error": "We couldn’t choose a book. Please try again.",
  "library.NextBook.results": "Your matches",
  "library.NextBook.matchCount": "{count} matches from {eligible} eligible books",
  "library.NextBook.reroll": "Reroll",
  "library.NextBook.missingMetadata": "Missing metadata: {fields}",
  "library.NextBook.openBook": "Open book",
  "library.NextBook.exclude": "Exclude",
  "library.NextBook.noMatches": "No books match all of those constraints",
  "library.NextBook.openLibrary": "Open your library",
  "library.NextBook.reason.genre_match": "Genre matches {value}",
  "library.NextBook.reason.language_match": "Language matches {value}",
  "library.NextBook.reason.page_limit": "Fits within {value} pages",
  "library.NextBook.reason.mood_match": "Mood matches your “{value}” shelf or tag",
  "library.NextBook.reason.format_match": "Format matches your “{value}” shelf or tag",
  "library.NextBook.reason.favorite": "Marked as a favorite in your library",
  "library.NextBook.reason.eligible": "Unread and available in your library",
  "library.NextBook.suggestion.add_to_read": "Add a book or mark one as To read.",
  "library.NextBook.suggestion.relax_constraints":
    "Remove one or more constraints and try again.",
  "library.NextBook.suggestion.add_metadata":
    "Add missing genre, language, page-count, shelf, or tag metadata.",
  "library.SeriesPanel.conflict": "Series information needs review",
  "library.SeriesPanel.conflictHelp":
    "Sources disagree about this order. Check the edition details before continuing.",
  "library.SeriesPanel.correct": "Correct series",
  "library.SeriesPanel.current": "Current",
  "library.SeriesPanel.eyebrow": "Part of a series",
  "library.SeriesPanel.hide": "Hide series for this book",
  "library.SeriesPanel.loadError": "We couldn't load this series",
  "library.SeriesPanel.loading": "Loading series information",
  "library.SeriesPanel.name": "Series name",
  "library.SeriesPanel.nextUnread": "Next unread volume",
  "library.SeriesPanel.openVolume": "Open volume",
  "library.SeriesPanel.orderUnknown": "Unordered",
  "library.SeriesPanel.position": "Position",
  "library.SeriesPanel.positionLabel": "Position label (optional)",
  "library.SeriesPanel.privateCorrectionHelp":
    "This correction is private to your library and will not change the shared catalog.",
  "library.SeriesPanel.save": "Save correction",
  "library.HelpPage.currentLimitation": "Current limitation",
  "library.HelpPage.description":
    "Guides for importing, organizing, and tracking your reading in Celsus.",
  "library.HelpPage.goToLibrary": "Go to your library",
  "library.HelpPage.importKindleLibrary": "Import a Kindle library",
  "library.HelpPage.importSteps": "Import the file",
  "library.HelpPage.kindleIntroduction":
    "Celsus imports a CSV copy of your Kindle library. Imports are previewed first and safely merged with books you already track.",
  "library.HelpPage.onThisPage": "On this page",
  "library.HelpPage.optionalColumns":
    "Reading Status and Current Page are optional. Pages, ISBN, Publisher, Published Year, and Language are also supported.",
  "library.HelpPage.prepareFile": "Prepare your CSV file",
  "library.HelpPage.readImportGuide": "Read the Kindle import guide",
  "library.HelpPage.requiredColumns":
    "Save the file as UTF-8 CSV with Title, Author, and ASIN columns. For example:",
  "library.HelpPage.safeAdvance":
    "Existing status and page progress only move forward; they are never reduced automatically.",
  "library.HelpPage.safeCreate":
    "Missing books are created, including books that have not been started.",
  "library.HelpPage.safePreserve":
    "Celsus preserves your titles, authors, notes, tags, shelves, ratings, and reading sessions.",
  "library.HelpPage.safeUpdates": "How repeat imports behave",
  "library.HelpPage.sessionLimitation":
    "Amazon does not provide exact session start and end times. This import updates books and available progress but does not create reading sessions.",
  "library.HelpPage.stepChooseFile": "Select Import books, then choose your CSV file.",
  "library.HelpPage.stepOpenLibrary": "Open Library from the main menu.",
  "library.HelpPage.stepReview":
    "Review new books, matches, and any rows that need a decision.",
  "library.HelpPage.stepStart": "Select Start import to apply the previewed changes.",
  "library.HelpPage.title": "Help & documentation",
  "library.BookActionsMenu.collections": "Collections",
  "library.BookActionsMenu.delete": "Delete",
  "library.BookActionsMenu.edit": "Edit",
  "library.BookActionsMenu.tags": "Tags",
  "library.BookCard.favorite": "Favorite",
  "library.BookCard.favorite2": "★ Favorite",
  "library.BookDetailPage.aboutThisBook": "About this book",
  "library.BookDetailPage.addEntry": "Add entry",
  "library.BookDetailPage.backToLibrary": "Back to Library",
  "library.BookDetailPage.bookDetails": "Book details",
  "library.BookDetailPage.bookNotFound": "Book not found",
  "library.BookDetailPage.collections": "Collections",
  "library.BookDetailPage.delete": "Delete",
  "library.BookDetailPage.description": "Description",
  "library.BookDetailPage.edit": "Edit",
  "library.BookDetailPage.invalidBookAddress": "Invalid book address",
  "library.BookDetailPage.lastRead": "Last read",
  "library.BookDetailPage.library": "Library",
  "library.BookDetailPage.loadingBookDetails": "Loading book details",
  "library.BookDetailPage.loadingBookJournal": "Loading book journal",
  "library.BookDetailPage.loadingReadingHistory": "Loading reading history",
  "library.BookDetailPage.logProgress": "Log progress",
  "library.BookDetailPage.min": "min",
  "library.BookDetailPage.noPrivateNotesQuotesHighlightsOrReflections":
    "No private notes, quotes, highlights, or reflections for this book yet.",
  "library.BookDetailPage.noReadingSessionsRecordedForThisBook":
    "No reading sessions recorded for this book yet.",
  "library.BookDetailPage.notesAndHighlights": "Notes and highlights",
  "library.BookDetailPage.of": "of",
  "library.BookDetailPage.page": "Page",
  "library.BookDetailPage.readingHistory": "Reading history",
  "library.BookDetailPage.readingProgress": "Reading progress",
  "library.BookDetailPage.tags": "Tags",
  "library.BookDetailPage.theAddressDoesNotContainAValid":
    "The address does not contain a valid book identifier.",
  "library.BookDetailPage.theBookWasnTDeleted": "The book wasn't deleted",
  "library.BookDetailPage.theFavoriteWasnTChanged": "The favorite wasn't changed",
  "library.BookDetailPage.thisBookMayHaveBeenDeletedOr":
    "This book may have been deleted or may not belong to your library.",
  "library.BookDetailPage.tryAgain": "Try again",
  "library.BookDetailPage.weCouldnTLoadTheReadingHistory":
    "We couldn't load the reading history",
  "library.BookDetailPage.weCouldnTLoadThisBook": "We couldn't load this book",
  "library.BookDetailPage.weCouldnTLoadThisBookS":
    "We couldn't load this book's journal",
  "library.BookDetailPage.yourActivity": "Your activity",
  "library.BookDetailPage.yourPrivateJournal": "Your private journal",
  "library.BookForm.addBookMethod": "Add book method",
  "library.BookForm.author": "Author",
  "library.BookForm.availableForExchange": "Available for exchange",
  "library.BookForm.availableForSale": "Available for sale",
  "library.BookForm.bookDetails": "Book details",
  "library.BookForm.cancel": "Cancel",
  "library.BookForm.catalogDetailsAdded": "Catalog details added",
  "library.BookForm.chooseAReadingStatusThenSaveIt":
    "”, choose a reading status, then save it.",
  "library.BookForm.condition": "Condition",
  "library.BookForm.coverImageUrl": "Cover image URL",
  "library.BookForm.currentPage": "Current page",
  "library.BookForm.description": "Description",
  "library.BookForm.editionAndCatalogDetails": "Edition and catalog details",
  "library.BookForm.eGTheLeftHandOfDarkness": "e.g. The Left Hand of Darkness",
  "library.BookForm.eGUrsulaKLeGuin": "e.g. Ursula K. Le Guin",
  "library.BookForm.enterManually": "Enter manually",
  "library.BookForm.exchangeAndSale": "Exchange and sale",
  "library.BookForm.exchangePrice": "Exchange price",
  "library.BookForm.genre": "Genre",
  "library.BookForm.https": "https://…",
  "library.BookForm.isbn": "ISBN",
  "library.BookForm.language": "Language",
  "library.BookForm.optional": "(optional)",
  "library.BookForm.pages": "Pages",
  "library.BookForm.mediaType": "Format",
  "library.BookForm.print": "Print",
  "library.BookForm.ebook": "Ebook",
  "library.BookForm.audiobook": "Audiobook",
  "library.BookForm.mixed": "Mixed format",
  "library.BookForm.durationSeconds": "Audiobook duration (seconds)",
  "library.BookForm.publicationYear": "Publication year",
  "library.BookForm.publisher": "Publisher",
  "library.BookForm.readingStatus": "Reading status",
  "library.BookForm.reviewTheDetailsFor": "Review the details for “",
  "library.BookForm.salePrice": "Sale price",
  "library.BookForm.searchCatalog": "Search catalog",
  "library.BookForm.theBookWasnTSaved": "The book wasn't saved",
  "library.BookForm.title": "Title",
  "library.BookForm.titleAndAuthorAreRequired": "Title and author are required.",
  "library.BooksPage.addToWishlist": "Add to wishlist",
  "library.BooksPage.importBooks": "Import books",
  "library.BooksPage.importBooksDescription":
    "Choose a Kindle, Goodreads, or generic CSV file. You can review every match before applying it.",
  "library.BooksPage.allTags": "All tags",
  "library.BooksPage.authorAZ": "Author A–Z",
  "library.BooksPage.clearFilters": "Clear filters",
  "library.BooksPage.favorites": "★ Favorites",
  "library.BooksPage.gridView": "Grid view",
  "library.BooksPage.libraryPagination": "Library pagination",
  "library.BooksPage.librarySections": "Library sections",
  "library.BooksPage.libraryView": "Library view",
  "library.BooksPage.listView": "List view",
  "library.BooksPage.loadingLibrary": "Loading library",
  "library.BooksPage.next": "Next",
  "library.BooksPage.of": "of",
  "library.BooksPage.page": "Page",
  "library.BooksPage.previous": "Previous",
  "library.BooksPage.recentlyAdded": "Recently added",
  "library.BooksPage.recentlyUpdated": "Recently updated",
  "library.BooksPage.searchByTitleOrAuthor": "Search by title or author",
  "library.BooksPage.searchYourLibrary": "Search your library…",
  "library.BooksPage.sortLibrary": "Sort library",
  "library.BooksPage.tag": "Tag",
  "library.BooksPage.theBookWasnTDeleted": "The book wasn't deleted",
  "library.BooksPage.theFavoriteWasnTChanged": "The favorite wasn't changed",
  "library.BooksPage.theReadingStateWasnTChanged": "The reading state wasn't changed",
  "library.BooksPage.titleAZ": "Title A–Z",
  "library.BooksPage.tryAgain": "Try again",
  "library.BooksPage.weCouldnTLoadYourLibrary": "We couldn't load your library",
  "library.CollectionsPage.allCollections": "All collections",
  "library.CollectionsPage.backToCollections": "Back to collections",
  "library.CollectionsPage.collectionNotFound": "Collection not found",
  "library.CollectionsPage.collectionPagination": "Collection pagination",
  "library.CollectionsPage.createACollection": "Create a collection",
  "library.CollectionsPage.createAShelfThenOrganizeBooksInto":
    "Create a shelf, then organize books into it from their detail pages.",
  "library.CollectionsPage.loadingCollectionBooks": "Loading collection books",
  "library.CollectionsPage.loadingCollections": "Loading collections",
  "library.CollectionsPage.manageCollections": "Manage collections",
  "library.CollectionsPage.next": "Next",
  "library.CollectionsPage.noCollectionsYet": "No collections yet",
  "library.CollectionsPage.of": "of",
  "library.CollectionsPage.openABookAndChooseOrganizeTo":
    "Open a book and choose Organize to add it here.",
  "library.CollectionsPage.page": "Page",
  "library.CollectionsPage.previous": "Previous",
  "library.CollectionsPage.thisCollectionIsEmpty": "This collection is empty",
  "library.CollectionsPage.thisCollectionMayHaveBeenRemovedOr":
    "This collection may have been removed or belongs to another account.",
  "library.CollectionsPage.tryAgain": "Try again",
  "library.CollectionsPage.weCouldnTLoadThisCollection":
    "We couldn't load this collection",
  "library.CollectionsPage.weCouldnTLoadYourCollections":
    "We couldn't load your collections",
  "library.ExternalBookSearch.aCatalogResultCanFillTheCover":
    "A catalog result can fill the cover, ISBN, publisher, year, and page count for you.",
  "library.ExternalBookSearch.authors": "Authors",
  "library.ExternalBookSearch.bookLanguage": "Book language",
  "library.ExternalBookSearch.catalogSource": "Catalog source",
  "library.ExternalBookSearch.chooseARecordToReviewItsDetails":
    "Choose a record to review its details",
  "library.ExternalBookSearch.description": "Description",
  "library.ExternalBookSearch.enterDetailsManuallyInstead":
    "Enter details manually instead",
  "library.ExternalBookSearch.findTheRightEdition": "Find the right edition",
  "library.ExternalBookSearch.fullBookInformation": "Full book information",
  "library.ExternalBookSearch.genres": "Genres",
  "library.ExternalBookSearch.identifiers": "Identifiers",
  "library.ExternalBookSearch.isbn": "ISBN",
  "library.ExternalBookSearch.language": "Language",
  "library.ExternalBookSearch.length": "Length",
  "library.ExternalBookSearch.loadMoreResults": "Load more results",
  "library.ExternalBookSearch.noMatchingBooks": "No matching books",
  "library.ExternalBookSearch.of": "of",
  "library.ExternalBookSearch.pages": "pages",
  "library.ExternalBookSearch.published": "Published",
  "library.ExternalBookSearch.publishers": "Publishers",
  "library.ExternalBookSearch.results": "results",
  "library.ExternalBookSearch.resultsSuppliedByOpenLibrary":
    "Results supplied by Open Library",
  "library.ExternalBookSearch.searchByTitleAuthorOrIsbn":
    "Search by title, author, or ISBN",
  "library.ExternalBookSearch.searchCatalog": "Search catalog",
  "library.ExternalBookSearch.searchingCatalog": "Searching catalog",
  "library.ExternalBookSearch.showing": "Showing",
  "library.ExternalBookSearch.subjects": "Subjects",
  "library.ExternalBookSearch.subtitle": "Subtitle",
  "library.ExternalBookSearch.theCatalogSearchFailed": "The catalog search failed",
  "library.ExternalBookSearch.title": "Title",
  "library.ExternalBookSearch.tryATitleAuthorOrIsbn": "Try a title, author, or ISBN",
  "library.ExternalBookSearch.useThisBook": "Use this book",
  "library.ExternalBookSearch.viewFullDetails": "View full details",
  "library.LibraryOrganizationDialog.add": "Add",
  "library.LibraryOrganizationDialog.collections": "Collections",
  "library.LibraryOrganizationDialog.eGCozy": "e.g. Cozy",
  "library.LibraryOrganizationDialog.eGSummerReading": "e.g. Summer reading",
  "library.LibraryOrganizationDialog.loadingOrganization": "Loading organization…",
  "library.LibraryOrganizationDialog.newCollectionName": "New collection name",
  "library.LibraryOrganizationDialog.newTagName": "New tag name",
  "library.LibraryOrganizationDialog.noCollectionsYet": "No collections yet.",
  "library.LibraryOrganizationDialog.noTagsYet": "No tags yet.",
  "library.LibraryOrganizationDialog.organizationWasnTUpdated":
    "Organization wasn't updated",
  "library.LibraryOrganizationDialog.save": "Save",
  "library.LibraryOrganizationDialog.tags": "Tags",
  "library.LibraryViewNavigation.libraryViews": "Library views",
  "library.BooksPage.collection": "Collection",
  "library.BooksPage.allCollections": "All collections",
  "library.SavedLibraryViews.title": "Saved views",
  "library.SavedLibraryViews.choose": "Choose a saved view",
  "library.SavedLibraryViews.loading": "Loading saved views…",
  "library.SavedLibraryViews.apply": "Apply",
  "library.SavedLibraryViews.update": "Update",
  "library.SavedLibraryViews.rename": "Rename",
  "library.SavedLibraryViews.delete": "Delete",
  "library.SavedLibraryViews.renamePrompt": "Rename saved view",
  "library.SavedLibraryViews.missingReference":
    "A collection or tag used by this view was deleted. The remaining filters will still apply.",
  "library.SavedLibraryViews.name": "Saved view name",
  "library.SavedLibraryViews.namePlaceholder": "e.g. Favorite unread books",
  "library.SavedLibraryViews.saveCurrent": "Save current view",
  "library.SavedLibraryViews.empty":
    "No saved views yet. Save the current filters to reuse them later.",
  "library.SavedLibraryViews.error": "The saved view change wasn’t completed",
  "library.bulk.toolbar": "Bulk library actions",
  "library.bulk.selected": "{count} selected",
  "library.bulk.status": "Reading status",
  "library.bulk.changeStatus": "Change status…",
  "library.bulk.manageCollection": "Add/remove collection…",
  "library.bulk.manageTag": "Add/remove tag…",
  "library.bulk.private": "Make private",
  "library.bulk.shared": "Allow profile sharing",
  "library.bulk.archive": "Archive",
  "library.bulk.restore": "Restore",
  "library.bulk.undo": "Undo last change",
  "library.bulk.recentActions": "Recent reversible actions",
  "library.bulk.undoAction": "Undo action",
  "library.bulk.failed": "The bulk change wasn’t applied",
  "library.bulk.archiveTitle": "Archive selected books?",
  "library.bulk.archiveDescription":
    "{count} selected books will leave the active library. Their history and organization are preserved and they can be restored.",
  "library.bulk.activeLibrary": "Active library",
  "library.bulk.archivedLibrary": "Archived books",
  "library.bulk.selectPage": "Select all books on this page",
  "library.bulk.selectBook": "Select {title}",
  "library.abandon.title": "Stop reading {title}?",
  "library.abandon.description":
    "Save where you stopped. There is no penalty, and you can return whenever you want.",
  "library.abandon.page": "Stopped at page (optional)",
  "library.abandon.reason": "Private reason (optional)",
  "library.abandon.privacy":
    "Your reason stays private and is never shown in reviews or community activity.",
  "library.abandon.cancel": "Keep reading",
  "library.abandon.save": "Mark as did not finish",
  "library.resume.title": "Return to {title}?",
  "library.resume.description": "Continue from page {page}, or restart from page zero.",
  "library.resume.continue": "Continue where I stopped",
  "library.resume.restart": "Restart from the beginning",
  "library.resume.history":
    "Restarting resets current progress only. Your earlier reading sessions remain in your private history and statistics.",
  "library.editionSwitch.action": "Change edition",
  "library.editionSwitch.title": "Change this edition",
  "library.editionSwitch.description":
    "Choose the exact catalog edition, preview progress changes, then confirm.",
  "library.editionSwitch.error": "The edition could not be changed",
  "library.editionSwitch.searchLabel": "Search by title, author, or edition",
  "library.editionSwitch.search": "Search",
  "library.editionSwitch.pages": "pages",
  "library.editionSwitch.preview": "Preview",
  "library.editionSwitch.confirmTitle": "Review the change",
  "library.editionSwitch.historyPreserved":
    "{sessions} reading sessions and {journals} journal entries keep their original edition attribution.",
  "library.editionSwitch.progressChoice": "How should current progress change?",
  "library.editionSwitch.keepPage": "Keep the same page",
  "library.editionSwitch.proportional": "Convert by percentage",
  "library.editionSwitch.reset": "Reset to page zero",
  "library.editionSwitch.back": "Choose another edition",
  "library.editionSwitch.confirm": "Confirm edition change",
  "library.editionSwitch.success": "Edition changed and reading history preserved",
  "library.lending.title": "Lending",
  "library.lending.private": "Private to you",
  "library.lending.overdue": "Overdue",
  "library.lending.due": "Due date",
  "library.lending.returned": "Mark returned",
  "library.lending.cancel": "Cancel record",
  "library.lending.borrower": "Borrower name or private label",
  "library.lending.note": "Private note (optional)",
  "library.lending.reminder": "Remind me in Celsus when overdue",
  "library.lending.save": "Record loan",
  "library.locations.manage": "Physical locations",
  "library.locations.privateHelp":
    "Locations stay private. Build a simple hierarchy such as Home / Office / Shelf 2.",
  "library.locations.name": "Location name",
  "library.locations.example": "Shelf, box, or room",
  "library.locations.parent": "Parent location",
  "library.locations.topLevel": "Top level",
  "library.locations.add": "Add location",
  "library.locations.save": "Save changes",
  "library.locations.cancel": "Cancel",
  "library.locations.delete": "Delete",
  "library.locations.renameMove": "Rename or move",
  "library.locations.error": "The location change wasn’t completed",
  "library.locations.filter": "Filter by physical location",
  "library.locations.all": "All locations",
  "library.locations.bulk": "Bulk physical location",
  "library.locations.assign": "Assign location…",
  "library.locations.clear": "No location",
} as const;
